import * as React from 'react';
import type { ImageCDNProvider } from '@packages/common';

import { ResponsiveImage } from './ResponsiveImage';
import { imageMappingToBreakpointFlag, imageMappingToConfigOverride } from './ResponsiveImageHelpers';
import { SchemalessImageMapping } from './ResponsiveImageTypes';

export interface SchemalessResponsiveImageProps {
  mapping: SchemalessImageMapping;
  title?: string;
  alt?: string;
  cdnProvider?: ImageCDNProvider;
}

export const SchemalessResponsiveImage: React.FC<SchemalessResponsiveImageProps> = ({
  mapping,
  title,
  alt,
  cdnProvider,
}) => {
  const configOverride = imageMappingToConfigOverride(mapping);
  const breakpoints = imageMappingToBreakpointFlag(mapping);
  const firstValidPath = Object.values(configOverride).find((url) => url !== null)?.filenameKey;
  const extension = firstValidPath?.includes('.') ? firstValidPath?.split('.').pop() : 'jpg';
  return (
    <ResponsiveImage
      extension={extension}
      alt={alt}
      title={title}
      path=""
      breakpoints={breakpoints}
      configOverride={configOverride}
      cdnProvider={cdnProvider}
    />
  );
};
